import { render, staticRenderFns } from "./SimpleLogoutLayout.vue?vue&type=template&id=fbee7096"
import script from "./SimpleLogoutLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLogoutLayout.vue?vue&type=script&lang=js"
import style0 from "./SimpleLogoutLayout.vue?vue&type=style&index=0&id=fbee7096&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports